export const confirmationGym = (all = false) => {
  let confirm = [];
  if (all) {
    confirm.push(
      all && {
        value: 3,
        label: 'همه',
      },
    );
  }
  const allConfirm = confirm.concat([
    {
      value: 0,
      label: 'در انتظار بررسی',
    },
    {
      value: 1,
      label: 'تایید',
    },
    {
      value: 2,
      label: 'رد',
    },
  ]);
  return allConfirm;
};
